export default "__VITE_ASSET__BedKR6jL__"